module.exports = __webpack_public_path__ + "static/img/newsBanner.294a45d.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/news/newsBanner.png
// module id = J4EW
// module chunks = 1